export const forWhom: string[] = [
  'Quieres tener siempre una actividad lista.',
  'Buscas ideas para tardes, fines de semana y vacaciones.',
  'Prefieres materiales sencillos.',
  'Quieres menos pantallas y más creatividad juntos.',
]

export interface IncludedBlock {
  emoji: string
  title: string
  description: string
  accent: string
}

export const included: IncludedBlock[] = [
  {
    emoji: '🎨',
    title: 'Manualidades',
    description: 'Pintar, recortar, pegar y construir.',
    accent: '#F27C70',
  },
  {
    emoji: '🎲',
    title: 'Juegos',
    description: 'Moverse, imaginar y divertirse en casa.',
    accent: '#6CBBD5',
  },
  {
    emoji: '🔬',
    title: 'Experimentos',
    description: 'Observar, probar y descubrir.',
    accent: '#2D8C5A',
  },
  {
    emoji: '💡',
    title: 'Retos creativos',
    description: 'Inventar historias, personajes y mundos.',
    accent: '#F6C453',
  },
]

export interface Backing {
  title: string
  text: string
  source: string
  href: string
}

export const backing: Backing[] = [
  {
    title: 'Juego y desarrollo',
    text: 'El juego ayuda a desarrollar habilidades cognitivas, sociales, emocionales y del lenguaje.',
    source: 'American Academy of Pediatrics',
    href: 'https://publications.aap.org/pediatrics/article/142/3/e20182058/38649/The-Power-of-Play-A-Pediatric-Role-in-Enhancing',
  },
  {
    title: 'Conexión',
    text: 'Las interacciones entre niños y adultos son clave durante el desarrollo.',
    source: 'Center on the Developing Child',
    href: 'https://developingchild.harvard.edu/',
  },
  {
    title: 'Equilibrio digital',
    text: 'Las pantallas no deberían desplazar el juego, el movimiento ni el tiempo familiar.',
    source: 'Media use recommendations',
    href: 'https://www.healthychildren.org/English/family-life/Media/Pages/default.aspx',
  },
]

export interface Testimonial {
  quote: string
  name: string
  country?: string
  avatar?: string
  initials: string
  accent: string
}

/** Editable fields — replace name, country and avatar with real reviews. */
export const testimonials: Testimonial[] = [
  {
    quote:
      'Tener todas las ideas organizadas nos cambió las tardes: elegimos una y empezamos.',
    name: 'VALENTINA.T',
    country: 'COLOMBIA 🇨🇴',
    initials: 'VT',
    accent: '#6CBBD5',
  },
  {
    quote: 'Casi todo se hace con cosas que ya tenemos en casa.',
    name: 'GABRIEL.V',
    country: 'MÉXICO 🇲🇽',
    initials: 'GV',
    accent: '#F6C453',
  },
  {
    quote: 'El Pasaporte es su parte favorita: quiere seguir completando retos.',
    name: 'PATRICIA.A',
    country: 'CHILE 🇨🇱',
    initials: 'PA',
    accent: '#F27C70',
  },
]

export interface FaqItem {
  q: string
  a: string
}

export const faqs: FaqItem[] = [
  {
    q: '¿Es un producto físico?',
    a: 'No. Es 100% digital y tendrás acceso justo después de tu compra.',
  },
  {
    q: '¿Para qué edades está pensado?',
    a: 'Para niños de 4 a 10 años. Muchas actividades se adaptan según la edad.',
  },
  {
    q: '¿Necesito comprar muchos materiales?',
    a: 'No. Se usan papel, cartón, colores, cajas y objetos cotidianos.',
  },
  {
    q: '¿Tengo que hacer una actividad cada día?',
    a: 'No. Cada familia usa las 365 ideas a su propio ritmo.',
  },
  {
    q: '¿Recibo los 10 bonos y el Pasaporte?',
    a: 'Sí, están incluidos con la oferta actual.',
  },
  {
    q: '¿Tiene garantía?',
    a: 'Sí, tienes 7 días para revisarlo. Si no es para ti, escribe al soporte dentro de ese plazo y te devolvemos el 100% de lo que pagaste.',
  },
]
